import axios from "./AxiosClient";
import { Constants } from "@socialcoach/services";
import { scCatchServiceException } from "@/annotations";

const KEYPHRASE_SERVICE = `${Constants.API_URL}/bedrock/keyphrases`;

export type KeyphrasePolicy = "FLAG" | "BLOCK" | "DISABLED";
type KeyphraseExtraParams = "post_keyphrases_count";

export interface Keyphrase {
  id: number;
  coachId: number;
  content: string;
  policy: KeyphrasePolicy;
  createdDate: string;
  updatedDate: string;
  postKeyphrasesCount?: number;
}

export interface KeyphraseFilterParams {
  policy: KeyphrasePolicy[] | KeyphrasePolicy;
  coachId?: number | string;
  playerId?: number | string;
  extraFields?: KeyphraseExtraParams[];
}

export interface UpdateKeyphraseRequest {
  policy: KeyphrasePolicy;
  phrases: string[];
}

export class KeyphraseServices {
  @scCatchServiceException()
  static async getKeyphrases(params?: KeyphraseFilterParams): Promise<Keyphrase[]> {
    const { data } = await axios.get<Keyphrase[]>(KEYPHRASE_SERVICE, { params });
    return data;
  }

  @scCatchServiceException()
  static async update(request: UpdateKeyphraseRequest): Promise<Keyphrase[]> {
    const { data } = await axios.post<Keyphrase[]>(`${KEYPHRASE_SERVICE}/update_list`, request);
    return data;
  }
}
